<template>
  <div class="exam">
    <div class="nuv">
      <span>签到&nbsp;&gt;</span>
      <span>{{ groupName }}</span>
    </div>
    <p>
      <el-button type="primary" @click="dialogVisible = true">发起签到</el-button>
    </p>
    <h3 style="margin: 20px 0;">签到记录</h3>
    <el-form :inline="true">
      <el-form-item label="签到人">
        <tjkautocomplete @callBack="updateTjkId"></tjkautocomplete>
      </el-form-item>
      <el-form-item label="发起签到时间">
        <el-date-picker v-model="queryStartTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始日期" @change='changeHandlerStart'></el-date-picker>
        <el-date-picker v-model="queryEndTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束日期" @change='changeHandlerEnd'></el-date-picker>
      </el-form-item>
      <el-form-item label="签到主题">
        <el-input v-model="name" style="width: 300px;" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">查询</el-button>
        <el-button type="primary" @click="getExcel">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" border highlight-current-row style="width: 100%">
      <el-table-column prop="startTime" label="发起签到时间" align="center"></el-table-column>
      <el-table-column prop="timeRule" label="签到规则" align="center"></el-table-column>
      <el-table-column prop="name" label="签到主题" align="center"></el-table-column>
      <el-table-column prop="tjkNumber" label="淘金号" align="center"></el-table-column>
      <el-table-column prop="tjkName" label="签到人" align="center">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="right-start">
            <p>真实姓名：{{ scope.row.realName }}</p>
            <p>淘金号：{{ scope.row.tjkNumber }}</p>
            <p>客服标签：{{ scope.row.tjkTypeTagName }}</p>
            <p>所属团队：{{ scope.row.providerName }}</p>
            <div slot="reference">
              <span>{{ scope.row.tjkName }}</span>
              <span v-if="scope.row.tjkTypeTag === 'ProviderService'">
                <img src="http://taojinyun.file.itaojin.cn/tjkTypeIconTuan.png" width="20px" />
              </span>
              <span v-else-if="scope.row.tjkTypeTag === 'SaleService'">
                <img src="http://taojinyun.file.itaojin.cn/tjkTypeIconXiao.png" width="20px" />
              </span>
              <span v-else-if="scope.row.tjkTypeTag === 'FreeService'">
                <img src="http://taojinyun.file.itaojin.cn/tjkTypeIconZi.png" width="20px" />
              </span>
              <span v-else-if="scope.row.tjkTypeTag === 'MerchantService'">
                <img src="http://taojinyun.file.itaojin.cn/tjkTypeIconShang.png" width="20px" />
              </span>
              <span v-else>
                <img src="http://taojinyun.file.itaojin.cn/tjkTypeIconYun.png" width="20px" />
              </span>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="checkInTime" label="签到时间" align="center"></el-table-column>
    </el-table>
    <pagination :pages="pages" :pageNum="pageNum" @getData="getList"></pagination>
    <!--发起签到-->
    <el-dialog title="发起签到" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-form :model="modal" ref="modal" :rules="rules" label-width="120px">
        <el-form-item label="签到主题" prop="name">
          <el-input v-model="modal.name" placeholder="请控制在5个字内" style="width: 300px;" clearable></el-input>
        </el-form-item>
        <el-form-item label="时间" prop="time">
          <el-select v-model="modal.time" clearable placeholder="请选择">
            <el-option key="1" label="1分钟内" value="1"></el-option>
            <el-option key="3" label="3分钟内" value="3"></el-option>
            <el-option key="5" label="5分钟内" value="5"></el-option>
            <el-option key="60" label="1小时内" value="60"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="addCheckIn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      'dialogVisible': false,
      'success': true,
      'message': '',
      'pageNum': 1,
      'pageSize': 10,
      'pages': 1,
      'groupId': this.$route.query.groupId,
      'groupName': this.$route.query.groupName,
      'tjkId': '',
      'queryStartTime': '',
      'queryEndTime': '',
      'name': '',
      'list': [],
      'modal': {
        name: '',
        time: ''
      },
      'rules': {
        name: [
          { required: true, message: '请输入签到主题', trigger: 'blur' },
          { min: 1, max: 5, message: '长度在 1 到 5 个字符', trigger: 'blur' }
        ],
        time: [
          { required: true, message: '请选择时间', trigger: 'change' }
        ]
      }
    }
  },
  mounted: function() {
    this.getList(1)
  },
  methods: {
    getList(num) {
      var data = {
        'groupId': this.groupId,
        'tjkId': this.tjkId,
        'queryStartTime': this.queryStartTime,
        'queryEndTime': this.queryEndTime,
        'name': this.name,
        'pageNum': num,
        'pageSize': this.pageSize
      }
      this.$http.post(API_ROOT.college + '/checkin/queryRecord', data).then(response => {
        var result = response.data
        if(result.success) {
          this.success = result.success
          this.message = result.msg
          this.pageNum = result.data.pageNum
          this.pages = result.data.pages
          this.list = result.data.list
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    },
    //弹出层关闭-发起签到
    handleClose() {
      this.$refs['modal'].resetFields()
      this.dialogVisible = false
    },
    //发起签到
    addCheckIn() {
      var self = this
      this.$refs.modal.validate((valid) => {
        if(valid) {
          self.modal.groupId = self.groupId
          self.$http.post(API_ROOT.college + '/checkin/add', self.modal).then(response => {
            var result = response.data
            if(result.success) {
              self.$message({
                message: '已添加',
                type: 'success',
                center: true,
                duration: 1000
              })
              self.handleClose()
              self.getList(1)
            }else {
              self.$alert(result.msg)
            }
          }, response => {
            self.$alert('网络繁忙，请稍后重试！')
          })
        }else {
          return false
        }
      })
    },
    //导出
    getExcel() {
      var arr = document.cookie.match(new RegExp('(^| )login_token=([^;]*)(;|$)'))
      var login_token = (arr != null) ? unescape(arr[2]) : null
      if(this.queryStartTime == null || this.queryEndTime == null) {
        this.queryStartTime = ''
        this.queryEndTime = ''
      }
      var url = API_ROOT.college + '/checkin/export/checkRecord?tjk_login_token=' + login_token + '&groupId=' + this.groupId + '&tjkId=' + this.tjkId + '&name=' + this.name + '&queryStartTime=' + this.queryStartTime + '&queryEndTime=' + this.queryEndTime
      window.open(url)
    },
    //淘金客自动搜索
    updateTjkId(val) {
      this.tjkId = val
    },
    //开始时间
    changeHandlerStart(val) {
      this.queryStartTime = val
    },
    //结束时间
    changeHandlerEnd(val) {
      this.queryEndTime = val
    }
  }
}
</script>


// WEBPACK FOOTER //
// ./src/page/college/groupCheckIn.vue